import { ToastProgrammatic } from 'buefy'

const Toast = {
    success: (message) => {
        show({
            type: "is-success",
            message: message,
        })
    },
    warn: (message) => {
        show({
            type: "is-warning",
            message: message,
        })
    },
    error: (message) => {
        show({
            type: "is-danger",
            message: message,
        })
    },
}

const show = ({
    type,
    message,
    position = "is-top-right",
    duration = 4000,
    queue = false,
}) => {
    ToastProgrammatic.open({
        type,
        message,
        position,
        duration,
        queue,
    })
}

export default Toast